import {apiTemplate} from "@/core/helpers/api.js";

export class Brands {
  static async getBrands() {
    const userLocale = localStorage.getItem('ngs-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        brands {
          edges {
            node {
              uuid
              name
            }
          }
        }
      }`
    );

    return await response;
  }
}